// MATOMO

import config from "../config";
import { customLog } from "../js/customlog.js";
import { formConfig } from '@/js/formConfig.js';
const log = (str, type) => { if ( config.isAdminNavAllowed ){ customLog(str, type); }}; 

export default {
  methods: {
    putMatomoScriptInPlace(){
      log("MATOMO SCRIPT", 'sep');
      let script = document.createElement('script');

      script.innerHTML = `
      var _paq = window._paq = window._paq || [];
      /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
        var u="https://promolife.matomo.cloud/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '6']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src='//cdn.matomo.cloud/promolife.matomo.cloud/matomo.js'; s.parentNode.insertBefore(g,s);
      })();
      `;
      // document.body.prepend(script);
      document.head.appendChild(script);
      log("Matomo mounted", 'low');
    }
  },
  beforeMount() {
    if (!formConfig.isPnGAction){
      this.putMatomoScriptInPlace();
    }
  },
}




